import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { UPLOAD_ADS } from './uploadAds.mutation';
import { UploadAds, UploadAdsVariables } from './__generated__/UploadAds';

export const useUploadAdsMutation = () => {
  return useMutation<UploadAds, UploadAdsVariables>(UPLOAD_ADS, {
    client: kmsClient
  });
};
